import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { virtualTerminalProxy } from '../../virtualTerminalProxy'
//import { AchAddModal } from '../../AchAddModal/AchAddModal'
import UnderlineLabelSection from '../../../../../../shared/components/ui/headings/UnderlineLabelSection'
import CustomerSection from './CustomerSection/CustomerSection'
import { BaseSection } from './BaseSection/BaseSection'
import AddressOverride from './AddressOverride/AddressOverride'
import { CreditCardDropDown } from './PaymentMethodSelectSection/CreditCardDropdown/CreditCardDropDown'
//import { AchDropDown } from './PaymentMethodSelectSection/AchDropdown/AchDropDown'

export function PaymentDetails (): ReactElement {
  const { customer } = useSnapshot(virtualTerminalProxy)

  return (
    <div style={{ width: '64%' }} className="bg-white shadow rounded mb-32 p-6">
      <UnderlineLabelSection labelText="Payment Details" />
      <BaseSection />
      <UnderlineLabelSection labelText="Customer Details" />
      <CustomerSection />
      {customer && (
        <>
          <AddressOverride />
          <UnderlineLabelSection labelText="Payment Method" />
          <CreditCardDropDown />
          {/*<AchDropDown />*/}
          {/*<AchAddModal />*/}
        </>
      )}
    </div>
  )
}
